export default "__VITE_ASSET__57377e83__"